import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { ApiServicesModule } from 'src/app/extensions/services/api/api-services.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LanguageRoutingModule } from './language-routing.module';
import { ChooseLanguageComponent } from './choose-language/choose-language.component';
import { LanguageDetailComponent } from './language-detail/language-detail.component';
import { ChooseDictionaryComponent } from './choose-dictionary/choose-dictionary.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    LanguageRoutingModule,
    ComponentsModule,
    ApiServicesModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
  ],
  providers: [],
  declarations: [ChooseLanguageComponent, LanguageDetailComponent, ChooseDictionaryComponent],
})
export class LanguageModule {}
